import { EllipsisVerticalIcon, PencilIcon, RotateCcwIcon, Trash2Icon } from "lucide-react";
import { observer } from "mobx-react-lite";

import {
  DropdownMenu,
  DropdownMenuBasicTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";
import { cn } from "@/lib/utils";

interface ChatMessageActionsProps {
  isUser: boolean;
  canEdit: boolean;
  onEdit: () => void;
  onDelete: () => void;
  onReplay?: () => void;
  disabled?: boolean;
}

export const ChatMessageActions = observer(
  ({ isUser, canEdit, onEdit, onDelete, onReplay, disabled = false }: ChatMessageActionsProps) => {
    if (disabled) {
      return null;
    }

    return (
      <DropdownMenu>
        <DropdownMenuBasicTrigger
          className={cn(
            "flex h-6 w-6 items-center justify-center rounded-md",
            "text-gray-400 hover:bg-gray-200 hover:text-gray-600",
          )}
        >
          <EllipsisVerticalIcon className="h-4 w-4" />
        </DropdownMenuBasicTrigger>
        <DropdownMenuContent
          align={isUser ? "end" : "start"}
          sideOffset={4}
          className="min-w-[140px]"
        >
          {onReplay && (
            <>
              <DropdownMenuItem
                onSelect={onReplay}
                className="flex w-full cursor-pointer items-center gap-2 text-sm"
              >
                <RotateCcwIcon className="h-3.5 w-3.5" />
                <span>Replay from here</span>
              </DropdownMenuItem>
              <DropdownMenuSeparator />
            </>
          )}
          {canEdit && (
            <>
              <DropdownMenuItem
                onSelect={onEdit}
                className="flex w-full cursor-pointer items-center gap-2 text-sm"
              >
                <PencilIcon className="h-3.5 w-3.5" />
                <span>Edit</span>
              </DropdownMenuItem>
              <DropdownMenuSeparator />
            </>
          )}
          <DropdownMenuItem
            onSelect={onDelete}
            className="flex w-full cursor-pointer items-center gap-2 text-sm text-red-600 focus:text-red-600"
          >
            <Trash2Icon className="h-3.5 w-3.5" />
            <span>Delete</span>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    );
  },
);
